import { RuntimeContract } from '@getvim/vim-connect';

export function getReferralAllConfig(): RuntimeContract.Incoming.UpdateReferralWritebackConfiguration {
  return {
    loadingWidgetId: 'optumCDataCore',
    displayLoadingWidget: true,
    overrideEhrFields: ['reasons'],
  };
}
